import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Stepper, Step, StepLabel, StepConnector } from '@mui/material/';
import { styled } from '@mui/material/styles';
import { HomeOutlined, Done, Close, StarOutline } from '@mui/icons-material';
import { $t, useTranslation } from '../../../../hooks/useTranslation';
const SetupStepper = forwardRef(({ currentStep, saving, steps, style, stepClick }, ref) => {
    useTranslation();
    const [stepCompleted, setStepCompleted] = useState(steps().map(() => false));
    const forwardNavClickHandler = (index, valid) => {
        if (valid) {
            setStepCompleted((prevState) => prevState.map((step, id) => id <= index || !!step));
        }
    };
    useImperativeHandle(ref, () => ({
        continueForwardNavigation(index, valid) {
            forwardNavClickHandler(index, valid);
        },
        setReviewStepComplete() {
            setStepCompleted((prevState) => prevState.map((step, id) => id === 10 || !!step));
        }
    }));
    const StyledIconRoot = styled('div')(({ ownerState }) => ({
        svg: {
            width: 20,
            height: 20
        },
        backgroundColor: '#B1B1B1',
        zIndex: 1,
        color: '#fff',
        width: 24,
        height: 24,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        ...(ownerState.active && {
            background: '#0097DC'
        }),
        ...(ownerState.completed && {
            background: '#0097DC'
        })
    }));
    // eslint-disable-next-line react/no-unstable-nested-components
    function HomeIcon({ active, completed, className }) {
        const icon = completed ? _jsx(Done, {}) : _jsx(HomeOutlined, {});
        return (_jsx(StyledIconRoot, { ownerState: { completed, active }, className: className, children: icon }));
    }
    // eslint-disable-next-line react/no-unstable-nested-components
    function CloseIcon({ active, completed, className }) {
        const icon = completed ? _jsx(Done, {}) : _jsx(Close, { style: { rotate: '45deg' } });
        return (_jsx(StyledIconRoot, { ownerState: { completed, active }, className: className, children: icon }));
    }
    // eslint-disable-next-line react/no-unstable-nested-components
    function StarIcon({ active, completed, className }) {
        const icon = completed ? _jsx(Done, {}) : _jsx(StarOutline, {});
        return (_jsx(StyledIconRoot, { ownerState: { completed, active }, className: className, children: icon }));
    }
    const iconComponent = (step) => {
        if (step === 'Start') {
            return HomeIcon;
        }
        if (step === 'General Ledger Dimensions') {
            return CloseIcon;
        }
        if (step === 'Review') {
            return StarIcon;
        }
        return null;
    };
    const stepClickHandler = (index) => {
        if (currentStep === index || saving) {
            return;
        }
        if (stepCompleted[index]) {
            stepClick(index);
        }
    };
    return (_jsx(Stepper, { activeStep: currentStep, style: style, orientation: "vertical", connector: _jsx(StepConnector, { style: { display: 'none' } }), children: steps().map((step, index) => {
            const stepProps = { completed: false };
            stepProps.completed = stepCompleted[index] && currentStep !== index;
            return (_jsx(Step, { ...stepProps, children: _jsx(StepLabel, { StepIconComponent: iconComponent(step), StepIconProps: { icon: index > 6 ? index - 1 : index }, style: {
                        flexDirection: 'row',
                        cursor: stepCompleted[index] ? 'pointer' : 'auto'
                    }, onClick: () => stepClickHandler(index), children: stepCompleted[index] || currentStep === index ? (_jsx("strong", { children: $t(step) })) : (step) }) }, step));
        }) }));
});
export default SetupStepper;
